(() => {
  const popup = document.querySelector('[data-lwes-discount-popup]');

  if (!popup) return;

  const dialog = popup.querySelector('[data-lwes-discount-popup-dialog]');
  const closeButtons = popup.querySelectorAll('[data-lwes-discount-popup-close]');
  const checkoutLink = popup.querySelector('[data-lwes-discount-popup-checkout]');
  const headingEl = popup.querySelector('[data-lwes-discount-popup-heading]');
  const messageEl = popup.querySelector('[data-lwes-discount-popup-message]');
  const codeTextEl = popup.querySelector('[data-lwes-discount-popup-code-text]');
  const buttonLabelEl = popup.querySelector('[data-lwes-discount-popup-button-label]');
  const termsEl = popup.querySelector('[data-lwes-discount-popup-terms]');
  const cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
  const cartAddPath = new URL(cartAddUrl, window.location.origin).pathname;

  let closeTimer;
  let lastFocusedElement;

  const defaults = {
    heading: headingEl ? headingEl.innerHTML : null,
    message: messageEl ? messageEl.innerHTML : null,
    codeText: codeTextEl ? codeTextEl.textContent : null,
    checkoutHref: checkoutLink ? checkoutLink.getAttribute('href') : null,
    buttonLabel: buttonLabelEl ? buttonLabelEl.textContent : null,
    terms: termsEl ? termsEl.innerHTML : null,
  };

  const updateContent = (overrides) => {
    if (!overrides) return;
    if (overrides.heading != null && headingEl) headingEl.textContent = overrides.heading;
    if (overrides.message != null && messageEl) messageEl.textContent = overrides.message;
    if (overrides.code != null && codeTextEl) codeTextEl.textContent = overrides.code;
    if (overrides.buttonLabel != null && buttonLabelEl) buttonLabelEl.textContent = overrides.buttonLabel;
    if (overrides.terms != null && termsEl) termsEl.textContent = overrides.terms;
  };

  const resetContent = () => {
    if (headingEl && defaults.heading != null) headingEl.innerHTML = defaults.heading;
    if (messageEl && defaults.message != null) messageEl.innerHTML = defaults.message;
    if (codeTextEl && defaults.codeText != null) codeTextEl.textContent = defaults.codeText;
    if (checkoutLink && defaults.checkoutHref != null) checkoutLink.setAttribute('href', defaults.checkoutHref);
    if (buttonLabelEl && defaults.buttonLabel != null) buttonLabelEl.textContent = defaults.buttonLabel;
    if (termsEl && defaults.terms != null) termsEl.innerHTML = defaults.terms;
  };

  const openPopup = (overrides) => {
    window.clearTimeout(closeTimer);
    if (overrides) updateContent(overrides);

    lastFocusedElement = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('lwes-discount-popup-open');

    requestAnimationFrame(() => {
      popup.classList.add('is-open');
      if (dialog) dialog.focus();
    });
  };

  const closePopup = () => {
    if (popup.hidden) return;

    popup.classList.remove('is-open');
    document.documentElement.classList.remove('lwes-discount-popup-open');

    closeTimer = window.setTimeout(() => {
      popup.hidden = true;
      resetContent();

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }, 260);
  };

  // Instead of relying on ?discount= in the URL (which Shopify can ignore),
  // we fetch /discount/CODE first to register the code in Shopify's server
  // session, then navigate to /checkout where the session applies it.
  if (checkoutLink) {
    checkoutLink.addEventListener('click', async (e) => {
      e.preventDefault();

      const code = codeTextEl ? codeTextEl.textContent.trim() : '';

      if (!code) {
        window.location.href = '/checkout';
        return;
      }

      checkoutLink.setAttribute('aria-busy', 'true');
      checkoutLink.style.pointerEvents = 'none';

      try {
        await fetch('/discount/' + encodeURIComponent(code), {
          credentials: 'include'
        });
      } catch {}

      window.location.href = '/checkout';
    });
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closePopup();
      return;
    }

    if (event.key !== 'Tab' || popup.hidden || !dialog) return;

    const focusableElements = dialog.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (!firstFocusable || !lastFocusable) return;

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  document.addEventListener('lwes:discount-popup:open', (event) => {
    const overrides = (event && event.detail && event.detail.overrides) || null;
    openPopup(overrides);
  });

  const isCartAddRequest = (resource) => {
    const url = typeof resource === 'string' ? resource : resource && resource.url;
    if (!url) return false;
    try {
      const path = new URL(url, window.location.origin).pathname;
      return path.replace(/\.js$/, '') === cartAddPath.replace(/\.js$/, '');
    } catch {
      return false;
    }
  };

  const isSuppressed = (headers) => {
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) return headers.has('X-LWES-Suppress-Popup');
    return Boolean(headers['X-LWES-Suppress-Popup'] || headers['x-lwes-suppress-popup']);
  };

  const isSuccessfulCartAdd = (payload) => {
    if (!payload || payload.status) return false;
    return Boolean(payload.id || payload.key || payload.items || payload.sections);
  };

  if (window.fetch) {
    const originalFetch = window.fetch.bind(window);

    window.fetch = (...args) => {
      const opts = args[1];
      const shouldWatch = isCartAddRequest(args[0]) && !isSuppressed(opts && opts.headers);

      return originalFetch(...args).then((response) => {
        if (shouldWatch && response.ok) {
          response.clone().json().then((payload) => {
            if (isSuccessfulCartAdd(payload)) openPopup(null);
          }).catch(() => {});
        }
        return response;
      });
    };
  }
})();
